import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface NextPageProps {
  currentPage: number;
  totalPages: number;
  nextPageUrl: string;
  prevPageUrl: string;
  nextTitle?: {
    en: string;
    ar: string;
  };
  nextDescription?: {
    en: string;
    ar: string;
  };
}
export function NextPage({
  currentPage,
  totalPages,
  nextPageUrl,
  prevPageUrl,
  nextTitle,
  nextDescription
}: NextPageProps) {
  const {
    isArabic
  } = useLanguage();
  return <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-12" data-id="element-1169">
      <Link to={prevPageUrl} className="flex items-center gap-2 px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors" data-id="element-1170">
        <ArrowLeftIcon className="w-4 h-4" data-id="element-1171" />
        <span data-id="element-1172">{isArabic ? 'السابق' : 'Previous'}</span>
      </Link>
      <div className="text-center text-sm text-gray-600 dark:text-gray-400" data-id="element-1173">
        {currentPage} / {totalPages}
      </div>
      {currentPage < totalPages ? <Link to={nextPageUrl} className="flex items-center justify-between gap-4 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1174">
          <div className="text-left" data-id="element-1175">
            <div className="font-medium" data-id="element-1176">
              {isArabic ? nextTitle?.ar || 'التالي' : nextTitle?.en || 'Next'}
            </div>
            {nextDescription && <div className="text-xs text-blue-100" data-id="element-1177">
                {isArabic ? nextDescription.ar : nextDescription.en}
              </div>}
          </div>
          <ArrowRightIcon className="w-4 h-4" data-id="element-1178" />
        </Link> : <Link to={nextPageUrl} className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors" data-id="element-1179">
          <span data-id="element-1180">{isArabic ? 'إنهاء' : 'Finish'}</span>
          <ArrowRightIcon className="w-4 h-4" data-id="element-1181" />
        </Link>}
    </div>;
}